import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";
import {
  faPlaneDeparture,
  faBoxesStacked,
  faPersonMilitaryPointing,
  faMapLocationDot,
  faCartFlatbed,
  faHandshake,
  faWarehouse,
  faHeadset,
  faTruckPlane,
  faBox,
} from "@fortawesome/free-solid-svg-icons";

const iconMap = {
  faPlaneDeparture,
  faBoxesStacked,
  faPersonMilitaryPointing,
  faMapLocationDot,
  faCartFlatbed,
  faHandshake,
  faWarehouse,
  faHeadset,
  faTruckPlane,
  faBox,
};

export const About = (props) => {
  return (
    <div id="about">
      <Helmet>
        <title>ABX Shipping - Nosotros</title>
      </Helmet>
      <div className="container">
        {/* Sección Nosotros */}
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img src="img/about.jpg" className="img-responsive" alt="" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Nosotros</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>¿Por qué elegirnos?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => <li key={i}>{d}</li>)
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => <li key={i}>{d}</li>)
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sección Servicios con ID */}
        <div id="services" className="text-center">
          <div className="section-title" style={{ marginTop: "80px" }}>
            <h2>Nuestros Servicios</h2>
            <p>
              Optimiza tus operaciones con nuestros servicios de transporte y
              almacenamiento.
            </p>
          </div>
          <div className="row">
            {props.data?.Services
              ? props.data.Services.map((d, i) => (
                  <div key={`service-${i}`} className="col-md-4 services">
                    <div className="services-icon">
                      <FontAwesomeIcon icon={iconMap[d.icon]} />
                    </div>
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                ))
              : "loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
